import { CreditCard } from 'lucide-react';

interface ReservationSourceSectionProps {
  source: string | null | undefined;
}

export function ReservationSourceSection({ source }: ReservationSourceSectionProps) {
  return (
    <section className="space-y-3">
      <h3 className="text-sm font-medium text-muted-foreground uppercase tracking-wider">
        Origem
      </h3>
      <div className="glass rounded-xl p-4">
        <div className="flex items-center gap-2 text-xs text-muted-foreground">
          <CreditCard className="w-4 h-4" />
          <span>Fonte: {source ?? '-'}</span>
        </div>
      </div>
    </section>
  );
}
